<template>
  <v-dialog
    v-model="show"
    persistent
    width="390px"
    max-width="100%"
  >
    <v-card
      flat
      class="d-flex flex-column"
      style="width: 390px; height: 416px; border-radius: 16px; box-sizing: border-box;"
    >
      <p class="subtitle-2 ma-0 mx-auto text-center">{{ $t('login.password.forgot-password') }}</p>

      <v-card-text class="px-0 py-2 mt-4">
        <p class="body-1 text-center">
          {{ $t('login.password.sms-info') }}
        </p>
      </v-card-text>

      <MessageBox v-if="requestFail" class="mt-2 mb-4" type="alert">
        <p>{{ $t('login.password.phone-missing') }}</p>
        <p v-html="$t('login.password.phone-missing-contact')"></p>
      </MessageBox>

      <v-form ref="form" class="mt-4" @submit.prevent="requestSMScode">
        <v-text-field
          v-model="mobilephone"
          outlined
          dense
          :label="$t('fields.mobilephone')"
          :rules="[rules.required, rules.phone]"
          :error-messages="error"
          @input="clearErrorMessages"
        />

        <ActionButton
          class="mt-2 v-btn--full-width"
          type="submit"
          :isDisabled="requestPending"
          @click="requestSMScode"
        >
          {{ $t('login.password.send-code-button') }}
        </ActionButton>

        <ActionButton class="mt-4 v-btn--full-width" type="secondary" @click="$emit('close')">
          <v-icon size="15" class="mr-4">$sl-close</v-icon>
          {{ $t('labels.cancel') }}
        </ActionButton>
      </v-form>  
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import { RulesMixin } from '@/components/mixins'
import ActionButton from '@/components/Common/ActionButton'
import MessageBox from '@/components/Common/MessageBox.vue'

export default {
  name: 'ForgotPasswordModal',

  components: {
    ActionButton,
    MessageBox
  },

  mixins: [RulesMixin],

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    mobilephone: '',
    error: '',
    requestFail: false,
    requestPending: false
  }),

  watch: {
    show(newVal) {
      if (!newVal) {
        this.resetState()
      }
    }
  },

  methods: {
    async requestSMScode() {
      this.requestFail = false
      this.clearErrorMessages()

      const valid = this.$refs.form?.validate()
      if (!valid) return

      this.requestPending = true

      try {
        const { data } = await API.requestSMScode({ mobilephone: this.mobilephone })

        if (data?.success) {
          this.$emit('close', {
            mobilephone: this.mobilephone,
            sentTime: new Date()
          })
          this.resetState()
        } else {
          this.requestFail = true
        }
      } catch (err) {
        this.error = this.$t('login.password.error-on-sms-send')
      } finally {
        this.requestPending = false
      }
    },

    clearErrorMessages() {
      this.error = ''
    },

    handleClose() {
      this.resetState()
      this.$emit('close')
    },

    resetState() {
      this.mobilephone = ''
      this.error = ''
      this.requestFail = false
      this.requestPending = false
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    }
  }
}
</script>